import { render, staticRenderFns } from "./DirectDebitWithdrawal.vue?vue&type=template&id=2b67a1ca"
import script from "./DirectDebitWithdrawal.vue?vue&type=script&lang=js"
export * from "./DirectDebitWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports